const Footer = ({ children }) => {
  return (
    <footer>
      {children}
      <p>
        &copy; AtomDev et Roy, 2022 &#128526; &#9996;
      </p>
    </footer>
  )
}

export default Footer